function accountMainText() {
	// $(".js-edit-accountMainText").on("click", function() {
	// 	$(this).parents('.accountMainText').toggleClass("is-edit");
	// });
	$(".accountMainText").on("click", function() {
		$(this).addClass("is-edit");
		$(this).find(".accountMainText__comment").focus();
	});
}

function accountMainTextClose(e) {
	var formTarget = $(".accountMainText");
	if (!formTarget.is(e.target) && formTarget.has(e.target).length === 0) {
		formTarget.removeClass("is-edit");
		e.stopPropagation();
	}
}